export const coordinateToString = (coord: google.maps.LatLngLiteral | google.maps.LatLng, separator = ', '): string => {
	const latitude = typeof coord.lat === 'function' ? coord.lat() : coord.lat
	const longitude = typeof coord.lng === 'function' ? coord.lng() : coord.lng

	return `${latitude}${separator}${longitude}`
}
